import { Product } from 'src/constants/schema';
import { OuterWrapper, Item, ContentStacked } from './FeaturedItems.styled';
import { FeaturedItemCard } from 'src/components/FeaturedItemCard/FeaturedItemCard';
import { useFirestoreCollection } from 'src/hooks/useFirestoreCollection';
import { logInfoToConsole } from 'src/utils/loggingUtils';
import { FirebaseProductsCollection } from 'src/constants/dataConstants';

/**
 * FeaturedItems component.
 * @returns The rendered component.
 */
export const FeaturedItems = () => {
    const {
        data: products,
        loading,
        error,
    } = useFirestoreCollection<Product>(FirebaseProductsCollection, {
        resolveRefs: ['brand', 'categories'],
    });

    const featuredProducts = products.filter((product) => product.isFeatured);
    const sortedFeaturedProducts = featuredProducts.sort((first, second) => second.position - first.position);

    if (loading) {
        return <div>. . .</div>;
    }

    if (error) {
        logInfoToConsole(`Error fetching featured products: ${error}`);
        return <div>Something went wrong! Please refresh the page.</div>;
    }

    return (
        <OuterWrapper>
            <ContentStacked>
                {sortedFeaturedProducts.map((product: Product, index: number) => {
                    const imageUrl = `productImages/${product.images[0].imageName}`;
                    const imageBackgroundColor = product.images[0].backgroundColor;
                    const isLastItem = index === sortedFeaturedProducts.length - 1;

                    return (
                        <Item key={product.id} isLastitem={isLastItem}>
                            <FeaturedItemCard
                                imageUrl={imageUrl}
                                brand={product.brand}
                                title={product.title}
                                links={product.links}
                                categories={product.categories}
                                backgroundColor={imageBackgroundColor}
                            />
                        </Item>
                    );
                })}
            </ContentStacked>
        </OuterWrapper>
    );
};
